var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{attrs:{"content-style":"background: #F2F2F2!important;","showBackButton":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [(!_vm.IS_LOADING.status)?_c('div',{staticClass:"content-container flex flex-col w-full px-8 pb-10"},[_c('VoucherForm',{ref:"voucherForm",attrs:{"data":_vm.data}})],1):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }